import * as React from 'react';
import { SVGProps } from 'react';

const SvgIcTicket = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      d="M3 15.75V5.25H18.75V15.75H3Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <ellipse cx={5.75} cy={8.75} rx={0.75} ry={0.75} fill="currentColor" />
    <ellipse cx={7.75} cy={8.75} rx={0.75} ry={0.75} fill="currentColor" />
    <ellipse cx={9.75} cy={8.75} rx={0.75} ry={0.75} fill="currentColor" />
    <ellipse cx={11.75} cy={8.75} rx={0.75} ry={0.75} fill="currentColor" />
    <ellipse cx={13.75} cy={8.75} rx={0.75} ry={0.75} fill="currentColor" />
    <ellipse cx={15.75} cy={8.75} rx={0.75} ry={0.75} fill="currentColor" />
    <path
      d="M19.5 8.33789H22.0588V19.148H5.65906V16.5"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <line
      x1={5}
      y1={12.25}
      x2={17}
      y2={12.25}
      stroke="currentColor"
      strokeWidth={1.5}
    />
  </svg>
);

export default SvgIcTicket;
